<template>
  <div
    class="bg-base-100 text-base-content h-full flex flex-col overflow-hidden"
  >
    <!-- Back button header -->
    <ThreadsNav show-back :show-center="false" />

    <VanEmpty
      v-if="questions.length === 0 && !loading"
      :description="`该角色还没有回答过任何问题`"
    />

    <ThreadList
      class="flex-1"
      ref="threadList"
      :on-pull-load="() => reload()"
      :on-scroll-load="() => loadNextPage()"
    >
      <div class="flex-1">
        <div class="p-4 space-y-4">
          <div
            v-for="(question, index) in questions"
            :key="index"
            class="card bg-base-200 shadow-md hover:shadow-lg transition-shadow cursor-pointer"
          >
            <div class="card-body p-4">
              <h3 class="text-base font-bold">{{ question.text }}</h3>
              <p class="text-xs text-base-content/70">
                {{ question.explanation }}
              </p>
              <div v-for="item in question.answerzz" :key="item.id">
                <div class="flex flex-col gap-2">
                  <div class="rounded-lg flex items-center gap-1">
                    <div class="w-10">
                      <UserAvatar :mate="item.mate" />
                    </div>
                    <p class="text-xs text-base-content/70 flex-1">
                      {{ item.mate!.name }}：
                    </p>
                  </div>
                  <p
                    class="text-xs text-base-content/70 prose prose-sm"
                    v-html="item.text"
                  />
                  <div v-if="item.audioMedia">
                    <AudioPlay
                      btn-class="btn-outline"
                      :url="item.audioMedia.url"
                    />
                  </div>
                </div>
              </div>
              <div class="flex justify-end">
                <button
                  class="btn btn-primary btn-sm"
                  @click="goToDetail(question)"
                >
                  <span class="text-xs">我来回答</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ThreadList>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ApiGetRoleplayQuestionMatePage } from "@/apis/roleplay";
import { RoleplayQuestion } from "@/types/entity";
import { ThreadListInstance } from "@/components/mobile/ThreadList.vue";
import { useMate } from "@/stores/mate";

const route = useRoute();
const router = useRouter();
const threadList = ref<ThreadListInstance>();

const reload = async () => {
  questions.value = [];
  threadList.value?.resetScrollLoadingState();
};

const questions = ref<RoleplayQuestion[]>([]);

const loading = ref(false);
const loadNextPage = async () => {
  const { length } = questions.value;
  const page = length / 5 + 1;
  if (length !== 0 && length % 5 !== 0) return false;
  if (page === 1) loading.value = true;

  const list = await ApiGetRoleplayQuestionMatePage({
    pagination: {
      page,
      perPage: 5,
    },
    filter: {
      mateId: Number(route.query.mateId),
      categoryId: Number(route.query.categoryId),
      type: "answered",
    },
    sort: {
      field: "dtUpdate",
      order: "desc",
    },
  });
  questions.value = [...questions.value, ...list.page.data];
  loading.value = false;
  return list.page.data.length === 5;
};

const mateStore = useMate();
const goToDetail = async (question: RoleplayQuestion) => {
  if (await mateStore.checkHasMate()) {
    router.push({
      name: "roleplayDetail",
      params: { uuid: question.uuid },
    });
  }
};
</script>
